<ion-item lines="none" class="info-bg cursor-ptr" mode="md" (click)="onClickCard()">
  <ion-avatar slot="start" *ngIf="icon1">
    <ion-img [src]="icon1 | getImagePipe"></ion-img>
  </ion-avatar>
  <ion-text class="lbl-12 lh-16 mt-8 mb-8" *ngIf="lbl1">{{lbl1 | getLanguagePipe}}</ion-text>
</ion-item>